import React from "react";
import { Button, Col, Form, Input, Modal, Row } from "antd";
import { ExclamationCircleOutlined, PlusOutlined, TableOutlined } from "@ant-design/icons";
import { Controller } from "react-hook-form";
import SimpleModal from "../../../../components/SimpleModal";
import Table from "../../../../components/Table";
import { formatCpfCnpj } from "../../../../utils/Masks";
import useRaffleBlacklist from "./useRaffleBlacklist";

const RaffleBlacklist: React.FC = () => {
    const {
        modalVisible,
        handleOpenModal,
        columns,
        tableData,
        rowSelection,
        isLoading,
        onClickTableRow,
        handleSubmitForm,
        handleSubmit,
        errors,
        control,
        isSubmiting,
        selectedIds,
        showTable,
        handleShowTable,
        handleDeleteCnpjInBlacklist,
        handleConfirmDeleteCnpjInBlacklist,
        handleCancelDeleteCnpjInBlacklist,
        cpfCnpjBeingDeleted,
        isDeleteModalVisible,
        isLoadingDelete,
        handleClickEdit
    } = useRaffleBlacklist();

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Button
                    danger
                    icon={<ExclamationCircleOutlined />}
                    onClick={handleOpenModal}
                    style={{
                        width: '100%',
                        fontWeight: 500,
                        borderRadius: 6,
                    }}
                >
                    {tableData.length} na lista de exclusão
                </Button>
            </div>

            <Modal
                open={modalVisible}
                title="CPF/CNPJ na lista de exclusão do sorteio"
                onCancel={handleOpenModal}
                footer={null}
                width={800}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12, paddingTop: 16 }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Button
                            type="primary"
                            icon={showTable ? <PlusOutlined /> : <TableOutlined />}
                            onClick={handleShowTable}
                        >
                            {!showTable ? 'Ver Tabela' : 'Adicionar'}
                        </Button>
                        <Button
                            type="default"
                            onClick={handleClickEdit}
                            disabled={selectedIds.length !== 1}
                        >
                            Editar
                        </Button>
                        <Button
                            type="primary"
                            danger
                            onClick={() => {
                                handleDeleteCnpjInBlacklist(selectedIds[0]);
                            }}
                            disabled={selectedIds.length !== 1}
                        >
                            Excluir
                        </Button>
                    </div>

                    {!showTable && (
                        <Form
                            onFinish={handleSubmit(handleSubmitForm)}
                            autoComplete="off"
                            layout="vertical"
                        >
                            <Row gutter={12} style={{ marginTop: 16 }} justify="space-between" align="middle">
                                <Col span={12}>
                                    <Form.Item
                                        label="Nome"
                                        required
                                        validateStatus={errors.name ? 'error' : 'success'}
                                        help={errors.name?.message}
                                    >
                                        <Controller
                                            name="name"
                                            control={control}
                                            rules={{ required: { value: false, message: 'Informe um nome para identificar o cnpj' } }}
                                            render={({ field }) => (
                                                <Input placeholder="Informe o nome" {...field} />
                                            )}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="CPF/CNPJ"
                                        required
                                        validateStatus={errors.cpfCnpj ? 'error' : 'success'}
                                        help={errors.cpfCnpj?.message}
                                    >
                                        <Controller
                                            name="cpfCnpj"
                                            control={control}
                                            rules={{ required: { value: false, message: 'Informe o CPF/CNPJ' } }}
                                            render={({ field: { onChange, ...field } }) => (
                                                <Input
                                                    onChange={(e) => onChange(formatCpfCnpj(e.target.value))}
                                                    placeholder="Informe o CPF/CNPJ"
                                                    {...field}
                                                />
                                            )}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Button
                                        type="primary"
                                        htmlType="button"
                                        disabled={isSubmiting}
                                        onClick={handleSubmit(handleSubmitForm)}
                                        style={{
                                            width: '100%',
                                        }}
                                    >
                                        Salvar
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    )}

                    {showTable && (
                        <Table
                            style={{ marginTop: 0 }}
                            columns={columns}
                            tableData={tableData}
                            rowSelection={rowSelection}
                            loading={isLoading}
                            onRow={(record, rowIndex) => {
                                return {
                                    onClick: () => { onClickTableRow(record, rowIndex); },
                                };
                            }}
                        />
                    )}
                </div>
            </Modal>

            <SimpleModal
                open={isDeleteModalVisible}
                onOk={handleConfirmDeleteCnpjInBlacklist}
                okButtonProps={{
                    disabled: isLoadingDelete,
                    loading: isLoadingDelete,
                }}
                cancelButtonProps={{
                    disabled: isLoadingDelete,
                }}
                okText="Deletar"
                onCancel={handleCancelDeleteCnpjInBlacklist}
                title={`Deseja realmente deletar "${cpfCnpjBeingDeleted?.name} (${cpfCnpjBeingDeleted?.cpfCnpj && formatCpfCnpj(cpfCnpjBeingDeleted?.cpfCnpj)})"?`}
            />
        </>
    );
};

export default RaffleBlacklist;
